"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/esnext.iterator.constructor.js");
require("core-js/modules/esnext.iterator.map.js");
var _react = _interopRequireWildcard(require("react"));
var _topicsForThisYear = require("../../topicsForThisYear");
var _speakerCardUtils = require("../../speakerCard/speakerCardUtils");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const HomePage = props => {
  let {
    t = key => key,
    soldOut = false,
    ticketsSoon = false,
    curatorsData,
    callForSpeakersExpirationDate,
    earlyBird = false,
    earlyBirdLink = ''
  } = props;
  const callForSpeakersDate = new Date(callForSpeakersExpirationDate);
  const isCallForSpeakersInFuture = callForSpeakersDate > new Date();
  const hasSixthSponsor = t("Pages.Home.Images.Sponsors.SixthSponsorUrl") && t("Pages.Home.Images.Sponsors.SixthSponsorUrl") !== "Pages.Home.Images.Sponsors.SixthSponsorUrl";
  (0, _react.useEffect)(() => {
    document.title = t("Pages.Home.Title");
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "con-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "con-content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "con-title-container"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "con-heading con-heading__h3 con-centered"
  }, t("Pages.Home.Header")), /*#__PURE__*/_react.default.createElement("div", {
    className: "con-subtitle con-text con-text__Xtra-larger-regular con-centered"
  }, t("Pages.Home.Heading").split("\n").map((line, index) => /*#__PURE__*/_react.default.createElement("p", {
    key: index,
    className: "con-title"
  }, line))), earlyBird && /*#__PURE__*/_react.default.createElement("div", {
    className: "con-centered con-centered__earlybird"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: earlyBirdLink || t("Pages.Home.TicketsLink"),
    target: "_blank",
    rel: "noopener noreferrer",
    className: "con-text con-text__Xtra-larger-regular con-text__Xtra-larger-regular--underline venue-links link-styles__1"
  }, "Early bird tickets available here"))), /*#__PURE__*/_react.default.createElement("div", {
    className: "banner-image-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "banner-image",
    style: {
      "--bg-image": "url(".concat(t("Pages.Home.Images.HomepageBanner"), ")"),
      "--bg-image-small": "url(".concat(t("Pages.Home.Images.HomepageBannerSmall"), ")")
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "sponsor-logos ".concat(hasSixthSponsor ? 'has-six-sponsors' : 'has-five-sponsors')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "logo logo-first"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: t("Pages.Home.Images.Sponsors.FirstSponsorUrl"),
    alt: t("Pages.Home.Images.Sponsors.FirstSponsorAlt")
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "logo logo-second"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: t("Pages.Home.Images.Sponsors.SecondSponsorUrl"),
    alt: t("Pages.Home.Images.Sponsors.SecondSponsorAlt")
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "logo logo-third"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: t("Pages.Home.Images.Sponsors.ThirdSponsorUrl"),
    alt: t("Pages.Home.Images.Sponsors.ThirdSponsorAlt")
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "logo logo-fourth"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: t("Pages.Home.Images.Sponsors.FourthSponsorUrl"),
    alt: t("Pages.Home.Images.Sponsors.FourthSponsorAlt")
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "logo logo-fifth"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: t("Pages.Home.Images.Sponsors.FifthSponsorUrl"),
    alt: t("Pages.Home.Images.Sponsors.FifthSponsorAlt")
  })), hasSixthSponsor && /*#__PURE__*/_react.default.createElement("div", {
    className: "logo logo-sixth"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: t("Pages.Home.Images.Sponsors.SixthSponsorUrl"),
    alt: t("Pages.Home.Images.Sponsors.SixthSponsorAlt")
  }))), isCallForSpeakersInFuture && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "height-zero trapezoid-section-background "
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "trapezoid-section-background"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "trapezoid-section-content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "icon-text-container"
  }, /*#__PURE__*/_react.default.createElement("object", {
    type: "image/svg+xml",
    data: t("Pages.Home.Images.CalendarIcon"),
    className: "trapezoid-icon"
  }, "Your browser does not support SVGs."), /*#__PURE__*/_react.default.createElement("p", {
    className: "con-text con-text__green-Capital"
  }, t("Pages.Home.FirstDay"))), /*#__PURE__*/_react.default.createElement("p", {
    className: "con-heading con-heading__h3 trapezoid-section-title"
  }, t("Pages.Home.CallForSpeakers")), /*#__PURE__*/_react.default.createElement("p", {
    className: "con-text con-text__large-regular trapezoid-section-text"
  }, t("Pages.Home.CallForSpeakersDescription"), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null)), /*#__PURE__*/_react.default.createElement("div", {
    className: "additional-button-border"
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "con-text__large-medium con-text__button con-text__button--green",
    onClick: () => window.open(t("Pages.Home.TicketsLink"), "_blank", "noopener,noreferrer")
  }, t("Pages.Home.RegisterToSpeak")))), /*#__PURE__*/_react.default.createElement("div", {
    className: "trapezoid-section-content"
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "homepage-photo-right",
    src: t("Pages.Home.Images.CallingSpeakersPhoto"),
    alt: t("Pages.Home.Images.CallingSpeakersPhotoAlt")
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "trapezoid-section-background"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "trapezoid-section-content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "icon-text-container"
  }, /*#__PURE__*/_react.default.createElement("object", {
    type: "image/svg+xml",
    data: t("Pages.Home.Images.CalendarIcon"),
    className: "trapezoid-icon"
  }, "Your browser does not support SVGs."), /*#__PURE__*/_react.default.createElement("p", {
    className: "con-text con-text__green-Capital"
  }, t("Pages.Home.FirstDay"))), /*#__PURE__*/_react.default.createElement("p", {
    className: "con-heading con-heading__h3 trapezoid-section-title"
  }, t("Pages.Home.FirstDayTitle")), t("Pages.Home.FirstDayDescription").split("\n").map((line, index) => /*#__PURE__*/_react.default.createElement("p", {
    key: index,
    className: "con-text con-text__large-regular trapezoid-section-text"
  }, line, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null))), /*#__PURE__*/_react.default.createElement("div", {
    className: "additional-button-border margin-top-10"
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "con-text__large-medium con-text__button con-text__button--green",
    disabled: soldOut,
    onClick: () => window.open(t("Pages.Home.TicketsLink"), "_blank", "noopener,noreferrer")
  }, ticketsSoon ? t("Navigation.Tickets") + t("Pages.Home.TicketsSoon") : soldOut ? t("Navigation.Tickets") + t("Pages.Home.TicketsSoldOut") : t("Navigation.Tickets")))), /*#__PURE__*/_react.default.createElement("div", {
    className: "trapezoid-section-content"
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "homepage-photo-right",
    src: t("Pages.Home.Images.FirstDayPhoto"),
    alt: t("Pages.Home.Images.FirstDayPhotoAlt")
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "trapezoid-section-background"
  }, /*#__PURE__*/_react.default.createElement(_topicsForThisYear.TopicsForThisYear, {
    t: t
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "trapezoid-section-background"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "trapezoid-section-content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "icon-text-container"
  }, /*#__PURE__*/_react.default.createElement("object", {
    type: "image/svg+xml",
    data: t("Pages.Home.Images.CalendarIcon"),
    className: "trapezoid-icon"
  }, "Your browser does not support SVGs."), /*#__PURE__*/_react.default.createElement("p", {
    className: "con-text con-text__green-Capital"
  }, t("Pages.Home.SecondDay"))), /*#__PURE__*/_react.default.createElement("p", {
    className: "con-heading con-heading__h3 trapezoid-section-title"
  }, t("Pages.Home.SecondDayTitle")), t("Pages.Home.SecondDayDescription").split("\n").map((line, index) => /*#__PURE__*/_react.default.createElement("p", {
    key: index,
    className: "con-text con-text__large-regular trapezoid-section-text"
  }, line, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null))), /*#__PURE__*/_react.default.createElement("div", {
    className: "additional-button-border"
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "con-text__large-medium con-text__button con-text__button--green button-event-edu",
    onClick: () => window.location.href = "/contact",
    disabled: soldOut
  }, ticketsSoon ? t("Pages.Home.ContactButton") + t("Pages.Home.TicketsSoon") : soldOut ? t("Pages.Home.FullyBooked") : t("Pages.Home.ContactButton")))), /*#__PURE__*/_react.default.createElement("div", {
    className: "trapezoid-section-content"
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "event-edu",
    src: t("Pages.Home.Images.SecondDayPhoto"),
    alt: t("Pages.Home.Images.SecondDayPhotoAlt")
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "trapezoid-section-background"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "con-speakers"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "con-text con-text__green-Capital con-text__green-Capital--large con-centered"
  }, t("Pages.Curators.Header")), /*#__PURE__*/_react.default.createElement("div", {
    className: "curators-content"
  }, /*#__PURE__*/_react.default.createElement(_speakerCardUtils.SpeakersRenderListOfCards, {
    assets_directory: t("Common.AssetsDirectory"),
    page: "curators",
    people: curatorsData,
    grid: 3
  }))))));
};
HomePage.propTypes = {
  t: _propTypes.default.func,
  soldOut: _propTypes.default.bool,
  ticketsSoon: _propTypes.default.bool,
  curatorsData: _propTypes.default.array,
  callForSpeakersExpirationDate: _propTypes.default.string,
  earlyBird: _propTypes.default.bool,
  earlyBirdLink: _propTypes.default.string
};
var _default = exports.default = HomePage;